import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';

const QuestionnaireForm = () => {
  const [questions, setQuestions] = useState([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' },]);
  const [submittedQuestions, setSubmittedQuestions] = useState([]);
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [showModal1, setShowModal1] = useState(false);
  const [showQuizimg, setShowQuizimg] = useState(false)
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    const storedToken = sessionStorage.getItem('token');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);
  const fetchData = () => {
    if (user && user.id) {
      fetch(`https://rvapi.emedha.in/pages/api/api/questions?userId=${user.id}`)
        .then((response) => response.json())
        .then((data) => setSubmittedQuestions(data))
        .catch((error) => console.error('Error fetching questions:', error));
    }
  }
  useEffect(() => { fetchData(); });
  const handleInputChange = (e, index, field, optionIndex = null) => {
    const { value } = e.target;
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      if (field === 'title') {
        updatedQuestions[index].title = value;
      } else if (field === 'question') {
        updatedQuestions[index].question = value;
      } else if (field === 'option') {
        updatedQuestions[index].options[optionIndex] = value;
      } else if (field === 'correctAnswer') {
        updatedQuestions[index].correctAnswer = value;
      } else if (field === 'correct_image') {
        updatedQuestions[index].correct_image = value;
      } else if (field === 'time') {
        updatedQuestions[index].time = value;
      }
      return updatedQuestions;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', questions[0].title);
    formData.append('question', questions[0].question);
    formData.append('correctAnswer', questions[0].correctAnswer);
    formData.append('correct_image', questions[0].correct_image);
    formData.append('userId', user ? user.id : null);
    formData.append('time', questions[0].time);
    questions[0].options.forEach((option, index) => {
      formData.append(`options[${index}]`, option);
    });
    if (showQuizimg) {
      for (let index = 0; index < 4; index++) {
        const inputElement = document.querySelector(`#fileInput${index}`);
        if (inputElement && inputElement.files.length > 0) {
          formData.append('files', inputElement.files[0]);
        }
      }
    }

    const url = editingQuestionId
      ? `https://rvapi.emedha.in/pages/api/api/questions/${editingQuestionId}`
      : `https://rvapi.emedha.in/pages/api/api/questions`;

    fetch(url, {
      method: editingQuestionId ? 'PUT' : 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === 'Question inserted successfully' || data.message === 'Question updated successfully') {
          alert('Your question has been successfully submitted!');
        } else {
          alert('There was an error submitting the question. Please try again.');
        }
        setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]);
        setShowModal1(false);
        setShowQuizimg(false);
      })
      .catch((error) => {
        alert('Error submitting question: ' + error.message);
        console.error('Error submitting question:', error);
      });
  };

  const handleEdit = (questionId) => {
    const questionToEdit = submittedQuestions.find((q) => q.id === questionId);
    setEditingQuestionId(questionId);
    setQuestions([
      {
        title: questionToEdit.title,
        question: questionToEdit.question,
        options: [
          questionToEdit.option_1,
          questionToEdit.option_2,
          questionToEdit.option_3,
          questionToEdit.option_4,
        ],
        correctAnswer: questionToEdit.correct_answer,
        correct_image: questionToEdit.correct_image,
        images1: questionToEdit.images1,
        images2: questionToEdit.images2,
        images3: questionToEdit.images3,
        images4: questionToEdit.images4,
        time: questionToEdit.time,
      },
    ]);

    if (questionToEdit.images1 || questionToEdit.images2 || questionToEdit.images3 || questionToEdit.images4) {
      setShowQuizimg(true);
      setShowModal1(false);
    } else {
      setShowModal1(true);
      setShowQuizimg(false);
    }
  };

  const handleDelete = (questionId) => {
    fetch(`https://rvapi.emedha.in/pages/api/api/questions/${questionId}`, {
      method: 'DELETE',
    }).then((response) => response.json())
      .then(() => {
        setSubmittedQuestions((prevQuestions) =>
          prevQuestions.filter((q) => q.id !== questionId)
        );
      })
      .catch((error) => console.error('Error deleting question:', error));
  };
  const navigate = useNavigate();
  const handleBack = () => { navigate(-1); };
  const handleGenerateUrl = () => {
    const randomString = Math.random().toString(36).substring(2, 100);
    navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList`);
  };
  const handleWithoutGenerateUrl = () => {
    const randomString = Math.random().toString(36).substring(2, 100);
    navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList1`);
  };
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    } else {
      console.log('No user data found in session storage');
    }
  }, []);
  useEffect(() => {
    if (user && user.id) {
      fetchEvents();
    } else {
      console.log('User is missing or incomplete');
    }
  }, [user]);
  const fetchEvents = async () => {
    if (!user || !user.id) {
      console.error('User ID is missing');
      return;
    }
    try {
      const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
      setEvents(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 10;
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = submittedQuestions.slice(indexOfFirstQuestion, indexOfLastQuestion);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate gpt

  const [topicx, setTopicx] = useState('');
  const [loading, setLoading] = useState(false);
  const [numQuestions, setNumQuestions] = useState(5);
  const handleGenerateQuiz = async () => {
    setLoading(true);
    try {
      if (!user) {
        console.error('User not found or not logged in');
        return;
      }
      if (!topicx.trim()) {
        console.error('Topic is empty');
        return;
      }
      const response = await axios.post('https://rvapi.emedha.in/pages/api/generate-quiz', {
        prompt: topicx,
        numberOfQuestions: numQuestions,
        model: 'text-davinci-003',
        max_tokens: 300,
        user: user.id,
      });

      const data = response.data;
      console.log('API Response:', data);
      const questionData = data.questionsx || [];
      const parsedQuestions = questionData
        .filter(q => q.question.trim() !== '')
        .map((q, index) => ({
          question: q.question,
          options: q.options || ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
          correctAnswer: q.correctAnswer || 'A',
        }));
      setSubmittedQuestions(parsedQuestions);
    } catch (error) {
      console.error('Error generating quiz:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px' }}>
      <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', }}>
        <img src={events.find((event) => event.flag === 1)?.file || ''} alt="Logo" style={{ width: '100px', }} />
        <div style={{ flexGrow: 1, textAlign: 'center' }}>
          <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600', }} >{events && events.length > 0 ? events[0].name : 'No event available'}</h2>
        </div>
      </div>

      <div className='mt-2 p-3' style={{ border: '2px solid black', borderRadius: '20px' }}>
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
            <div className="d-flex align-items-center gap-2">
              <IoArrowBackCircle onClick={handleBack} style={{ cursor: 'pointer', fontSize: '1.8rem' }} />
              <h1 className="m-0" style={{ fontSize: '1.5rem' }}>Quiz</h1>
            </div>
            <div className="d-flex flex-wrap gap-2 justify-content-center">
              <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); setShowModal1(true); setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); }} style={{ borderRadius: '20px' }}>+ Add Quiz</button>
              <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); setShowQuizimg(true); setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); }} style={{ borderRadius: '20px' }}>+ Add Images Quiz</button>
              <button className="btn btn-primary btn-sm" onClick={handleWithoutGenerateUrl} style={{ borderRadius: '20px' }}>Generate URL(No Cert)</button>
              <button className="btn btn-primary btn-sm" onClick={handleGenerateUrl} style={{ borderRadius: '20px' }}>Generate URL(With Cert)</button>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mb-4 mt-2">
        <div className="d-flex mb-3 gap-2 flex-wrap align-items-center justify-content-center" style={{ borderRadius: '20px', border: 'solid 2px black', padding: '10px' }}>
          <div className="col-12 col-md-5">
            <input
              type="text"
              className="form-control"
              value={topicx}
              onChange={(e) => setTopicx(e.target.value)}
              placeholder="Enter a topic for the quiz"
              style={{ borderRadius: '20px' }}
            />
          </div>

          <div className="col-12 col-md-3">
            <input
              type="number"
              className="form-control"
              value={numQuestions}
              min={1}
              max={50}
              onChange={(e) => setNumQuestions(Number(e.target.value))}
              placeholder="Number of questions"
              style={{ borderRadius: '20px' }}
            />
          </div>

          <div className="col-12 col-md-3 d-grid">
            <button
              className="btn btn-primary"
              onClick={handleGenerateQuiz}
              disabled={loading || !topicx.trim()}
              style={{ borderRadius: '20px' }}
            >
              {loading ? 'Generating...' : 'Generate Quiz'}
            </button>
          </div>
        </div>

      </div>

      <form onSubmit={handleSubmit}>
        {showModal1 && (
          <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-content" style={{ maxWidth: '1000px', margin: '100px auto', backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
              <div>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <div key={index} className="mb-4">
                      <div className="row">
                        <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Title:</label>
                        <div className="col-12">
                          <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-6">
                          <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
                          <div className="col-12">
                            <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
                          <div className="col-12">
                            <select required value={question.time || ''} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }}>
                              {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
                                <option key={minute} value={minute}>{minute} minute{minute > 1 ? 's' : ''}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '600', marginBottom: '5px', color: '#333' }}>Options:</label>
                        <div className="row">
                          {question.options.map((option, optionIndex) => (
                            <div key={optionIndex} className="col-12 col-md-6 mb-2">
                              <input type="text" value={option} onChange={(e) => handleInputChange(e, index, 'option', optionIndex)} placeholder={`Option ${String.fromCharCode(65 + optionIndex)}`} required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-12 col-form-label" style={{ fontWeight: '600', marginBottom: '5px', color: '#333' }}>Correct Answer:</label>
                        <div className="col-12">
                          <input type="text" value={question.correctAnswer} onChange={(e) => handleInputChange(e, index, 'correctAnswer')} placeholder="Enter correct answer" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1rem', width: '100%', }}>Submit</button>
                <button onClick={() => setShowModal1(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1rem', width: '100%', marginTop: '10px', }}>Close</button>
              </div>
            </div>
          </div>
        )}
      </form>

      <form onSubmit={handleSubmit}>
        {showQuizimg && (
          <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-content" style={{ maxWidth: '1000px', margin: '100px auto', backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
              <div>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <div key={index} className="mb-4">
                      <div className="row">
                        <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Title:</label>
                        <div className="col-12">
                          <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-6">
                          <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
                          <div className="col-12">
                            <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
                          <div className="col-12">
                            <select required value={question.time || ''} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }}>
                              {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
                                <option key={minute} value={minute}>{minute} minute{minute > 1 ? 's' : ''}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '600', marginBottom: '5px', color: '#333' }}>Options:</label>
                        <div className="row">
                          {question.options.map((option, optionIndex) => (
                            <div key={optionIndex} className="col-12 col-md-6 mb-2">
                              <label htmlFor={`fileInput${optionIndex}`} style={{ fontWeight: '500', color: '#333' }}>{optionIndex + 1}.</label>
                              <input type="file" id={`fileInput${optionIndex}`} style={{ width: '100%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc' }} />
                              {question[`images${optionIndex + 1}`] && (
                                <div>
                                  <img src={question[`images${optionIndex + 1}`]} alt={`Option ${String.fromCharCode(65 + optionIndex)}`} style={{ height: '50px', marginTop: '10px' }} />
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-12 col-form-label" style={{ fontWeight: '600', marginBottom: '5px', color: '#333' }}>Correct Answer Image No:</label>
                        <div className="col-12">
                          <input type="number" value={question.correct_image} onChange={(e) => handleInputChange(e, index, 'correct_image')} placeholder="Enter correct image No" required style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' }} />
                          {question.correct_image && (
                            <div>
                              <img src={question.correct_image} alt="Correct answer image" style={{ width: '100px', height: 'auto', marginTop: '10px' }} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1rem', width: '100%', }}>Submit</button>
                <button onClick={() => setShowQuizimg(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1rem', width: '100%', marginTop: '10px', }}>Close</button>
              </div>
            </div>
          </div>
        )}

      </form>

      <div className="mt-2">
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr style={{ backgroundColor: '#28a745', color: '#fff' }}>
                <th>#</th>
                <th>Title</th>
                <th>Question</th>
                <th>Options</th>
                <th>Correct Answer</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {submittedQuestions.map((question, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{question.title}</td>
                  <td>{question.question}</td>
                  <td>
                    {['option_1', 'option_2', 'option_3', 'option_4'].map((optionKey, optionIndex) => {
                      const imageKey = `images${optionIndex + 1}`;
                      const imageUrl = question[imageKey];

                      if (imageUrl) {
                        return (
                          <div key={optionIndex} className="mb-1">
                            <img
                              src={imageUrl}
                              style={{ height: '50px', maxWidth: '100%' }}
                              alt={`Option ${String.fromCharCode(65 + optionIndex)}`}
                            />
                          </div>
                        );
                      } else if (question[optionKey]) {
                        return (
                          <div key={optionIndex} className="mb-1">
                            {String.fromCharCode(65 + optionIndex)}. {question[optionKey]}
                          </div>
                        );
                      }
                      return null;
                    })}
                  </td>

                  <td>
                    {question.correct_answer && <div>{question.correct_answer}</div>}
                    {question.correct_image && (
                      <div>
                        <img
                          src={question.correct_image}
                          alt="Correct answer image"
                          style={{ width: '100px', height: 'auto', maxWidth: '100%' }}
                        />
                      </div>
                    )}
                  </td>

                  <td className="text-center">
                    <button
                      onClick={() => handleEdit(question.id)}
                      className="btn btn-warning btn-sm me-2"
                    >
                      <FaEdit />
                    </button>
                    <button onClick={() => handleDelete(question.id)} className="btn btn-danger btn-sm">
                      <FaTrashAlt />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


      <div className="pagination" style={{ textAlign: 'center', marginTop: '20px', marginBottom: '80px' }}>
        <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} disabled={currentPage === 1}>Previous</button>
        <span style={{ margin: '0 10px' }}>Page {currentPage} of {Math.ceil(submittedQuestions.length / questionsPerPage)}</span>
        <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage < Math.ceil(submittedQuestions.length / questionsPerPage) ? currentPage + 1 : currentPage)} disabled={currentPage === Math.ceil(submittedQuestions.length / questionsPerPage)}>Next</button>
      </div>

      <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
        <p>© 2025 E-medha technologies. All rights reserved.</p>
      </footer>

    </div>
  );
};

export default QuestionnaireForm;


